// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3C9LO","title":"BackImages_title__OoofN","images":"BackImages_images__Kdafp"};